import { applicantStore } from '../ApplicantStore';
import { notificationStore } from 'components/layout/notifications/NotificationStore';

const EMAIL_EXISTS_MESSAGE = 'A candidate with this email already exists';
const LINKEDIN_EXISTS_MESSAGE =
	'A candidate with this LinkedIn URL already exists';
const VERIFY_ERROR_MESSAGE =
	'Unable to verify. Please check your connection and try again.';

export function notifyDuplicateApplicant({ applicantId, message } = {}) {
	if (!applicantId) return;

	notificationStore.pushNotification({
		type: notificationStore.ERROR_NOTIFICATION,
		title: 'Candidate Already Created',
		message:
			message || 'A candidate with this email or LinkedIn URL already exists.',
		action: {
			label: 'See Profile',
			href: `/ats/candidates/${applicantId}`
		}
	});
}

export function withApplicantEmailUniqueValidation(
	emailSchema,
	excludeApplicantId,
	onDuplicate
) {
	return emailSchema.test(
		'unique-email',
		EMAIL_EXISTS_MESSAGE,
		async function (value) {
			if (!value) return true;

			try {
				const result = await applicantStore.checkDuplicate({
					email: value,
					excludeId: excludeApplicantId
				});
				if (result?.data?.emailExists) {
					onDuplicate?.({
						applicantId: result.data.emailApplicantId,
						message: EMAIL_EXISTS_MESSAGE
					});
					return false;
				}
				return true;
			} catch {
				return this.createError({ message: VERIFY_ERROR_MESSAGE });
			}
		}
	);
}

export function withApplicantLinkedinUniqueValidation(
	linkedinSchema,
	excludeApplicantId,
	onDuplicate
) {
	return linkedinSchema.test(
		'unique-linkedin',
		LINKEDIN_EXISTS_MESSAGE,
		async function (value) {
			if (!value || !String(value).trim()) return true;

			const linkedinUrl = String(value).trim();

			try {
				const result = await applicantStore.checkDuplicate({
					linkedinUrl,
					excludeId: excludeApplicantId
				});
				if (result?.data?.linkedinUrlExists) {
					onDuplicate?.({
						applicantId: result.data.linkedinUrlApplicantId,
						message: LINKEDIN_EXISTS_MESSAGE
					});
					return false;
				}
				return true;
			} catch {
				return this.createError({ message: VERIFY_ERROR_MESSAGE });
			}
		}
	);
}
